import { useEffect, useState } from "react";
import styles from "./pinatareport.module.css";
import { Button, Checkbox, Chip, Dialog, DialogContent, DialogTitle, FormControl, InputLabel, ListItemText, MenuItem, Box, Select, Typography } from "@mui/material";
import { ArrowLeft, ArrowRight, Calendar, Download, Filter, Home, Search, X } from "react-feather";
import Helmet from "react-helmet";
import { withAuthenticationRequired, useAuth0 } from "@auth0/auth0-react";
import { TableLoader } from "../../../components/LoaderC";
import Footer from "../../../components/Footer";
import Loader from "../../../components/Loader";
import axios from "axios";
import { Link } from "react-router-dom";
import ReportList from "./components/ReportList";
import dayjs from "dayjs";
import { useHistory } from "react-router-dom";
import { DatePicker } from "rsuite";

const Initials = ({ fullName }) => {
    const parts = fullName.trim().split(" ");
    if (parts.length >= 2) {
        return (
            parts[0].charAt(0).toUpperCase() +
            parts[parts.length - 1].charAt(0).toUpperCase()
        );
    }
    return parts[0].substring(0, 2).toUpperCase();
}

const PinataReport = () => {
    const redirect = useHistory();
    const { getAccessTokenSilently } = useAuth0();
    const [loading, setLoading] = useState(false);
    const [contentLoading, setContentLoading] = useState(true);
    const [filterOpen, setFilterOpen] = useState(false);
    const [allRentrolls, setAllRentrolls] = useState([]);
    const [rentrollList, setRentrollList] = useState([]);
    const [filterData, setFilterData] = useState({ searchKey: "", email_group: "" });
    const [emailGroupList, setEmailGroupList] = useState([]);
    const [openExportModal, setOpenExportModal] = useState(false);
    const [selectedEmailGroups, setSelectedEmailGroups] = useState([]);
    const [filterDate, setFilterDate] = useState(null);

    useEffect(() => {
        async function getRentrolls() {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

            axios(process.env.REACT_APP_USER_API_URL + "v1/report/pinata", {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }).then((response) => {
                setContentLoading(false);
                setAllRentrolls(response.data.data);
            }).catch((error) => {
                setContentLoading(false);
            });
        }

        async function getRentrollsWithMonth() {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

            axios(process.env.REACT_APP_USER_API_URL + "v1/report/pinata", {
                params: { month: filterDate },
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }).then((response) => {
                setContentLoading(false);
                setAllRentrolls(response.data.data);
            }).catch((error) => {
                setContentLoading(false);
            });
        }

        if (filterDate) {
            getRentrollsWithMonth();
        } else {
            getRentrolls();
        }
    }, [getAccessTokenSilently, filterDate]);

    useEffect(() => {
        let filterredDataTemp = allRentrolls;

        if (filterData?.searchKey !== "") {
            let inputVal = filterData?.searchKey;
            inputVal = inputVal.toLowerCase();
            filterredDataTemp = filterredDataTemp.filter((item) => item?.tenant_data?.name?.toLowerCase().includes(inputVal) || item?.tenant_data?.email?.toLowerCase().includes(inputVal) || item?.property_data?.name?.toLowerCase().includes(inputVal) || item?.apt_name?.toLowerCase().includes(inputVal) || item?.rent?.toString().includes(inputVal) || item?.available_balance2?.toString().includes(inputVal));
        }

        if (filterData?.email_group !== "" && filterData?.email_group !== "all") {
            let selectedGroup = emailGroupList?.filter(i => i?.id === filterData?.email_group);
            if (selectedGroup.length > 0) {
                selectedGroup = selectedGroup[0];

                let tenantIds = selectedGroup?.contacts?.map(i => {
                    return i?.tenant_id;
                });

                filterredDataTemp = filterredDataTemp.filter((i) => tenantIds.indexOf(i.tenant_info_id) > -1);
            }
        }

        setRentrollList(filterredDataTemp);
    }, [allRentrolls, filterData]);

    useEffect(() => {
        async function getEmailGroups() {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

            axios(process.env.REACT_APP_USER_API_URL + "v1/tenant-email-group", {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }).then((response) => {
                setEmailGroupList(response.data.data);
            }).catch((error) => { });
        }
        getEmailGroups();
    }, [getAccessTokenSilently]);

    const exportTenants = async () => {
        try {
            setLoading(true);
            setOpenExportModal(false);

            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

            const response = await axios.get(process.env.REACT_APP_USER_API_URL + "v1/report/pinata-report-export",
                {
                    params: { email_groups: selectedEmailGroups },
                    responseType: "blob",
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            setLoading(false);

            const url = window.URL.createObjectURL(
                new Blob([response.data])
            );

            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "PinataReport.xlsx");
            document.body.appendChild(link);
            link.click();
            link.remove();

            window.URL.revokeObjectURL(url)

        } catch (error) {
            setLoading(false);
            console.error("Export failed", error);
        }
    }

    return (<>
        <Helmet title="Pinata Reports" />
        {loading && <Loader />}
        <div className={`${styles.pageTitleWrap}`}>
            <Typography display="inline" className={`${styles.pageTitle}`}>Pinata Report</Typography>
            <nav aria-label="breadcrumb">
                <ol className={`${styles.breadcrumb}`}>
                    <li className={`${styles.breadcrumbItem}`}><span><Home /></span>Report</li>
                    <li className={`${styles.breadcrumbItem} ${styles.active}`}>Pinata Report</li>
                </ol>
            </nav>
        </div>

        <div className={`${styles.BodyCon}`}>
            <div className={`${styles.mainCardDiv}`}>
                <div className={`${styles.mainCard}`}>
                    <div className="control-pane">
                        {contentLoading && (<div className="Loader TableLoader"><TableLoader /></div>)}

                        <div className={`${styles.Row}`}>

                            {!contentLoading && <>
                                <div className={`${styles.SearchFilterSec}`}>
                                    <div className={`${styles.SearchCon}`}>
                                        <div className={`${styles.SearchConSec}`}>
                                            <Search />
                                            <input type="text" placeholder="Search" value={filterData?.searchKey} onChange={(e) => { setFilterData((prev) => { return { ...prev, searchKey: e.target.value }; }); }} />
                                        </div>
                                    </div>

                                    <div className={`${styles.FilterSec}`}>
                                        <div className={filterOpen === true ? `${styles.FilterFieldSec} ${styles.Open}` : `${styles.FilterFieldSec}`}>
                                            <p className={`${styles.FilterTitle}`}>
                                                Filters
                                                <span onClick={(e) => setFilterOpen(false)}>
                                                    <ArrowRight />
                                                </span>
                                            </p>
                                            <div className={`${styles.FilterCard} ${styles.Select} CusSelectFilter Filter`}>
                                                <FormControl fullWidth>
                                                    <InputLabel id="demo-simple-select-label">Email Group</InputLabel>
                                                    <Select
                                                        labelId="demo-simple-select-label"
                                                        id="demo-simple-select"
                                                        label="Email Group"
                                                        value={filterData?.email_group}
                                                        onChange={(e) => {
                                                            setFilterData((prev) => { return { ...prev, email_group: e.target.value }; });
                                                        }}
                                                    >
                                                        <MenuItem value={'all'}>No Group</MenuItem>
                                                        {emailGroupList?.map((i) => {
                                                            return (<MenuItem value={i.id}>{i.title}</MenuItem>);
                                                        })}
                                                    </Select>
                                                </FormControl>
                                            </div>
                                            <div className={`${styles.FilterCard} ${styles.Select} CusSelectFilter DashFilterSec Filter`}>
                                                <DatePicker
                                                    oneTap
                                                    format="MMM yyyy"
                                                    placeholder={"Select Month"}
                                                    placement={"bottomEnd"}
                                                    disabledDate={(date) => date > new Date()}
                                                    caretAs={Calendar}
                                                    onChange={(date) => {
                                                        if (date) {
                                                            setFilterDate(dayjs(date).format('YYYY-MM-01'));
                                                        } else {
                                                            setFilterDate(null);
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <Link className={`${styles.FilterBu}`} onClick={(e) => setFilterOpen(true)}>
                                            <Filter />
                                        </Link>
                                        <Link className={`${styles.AddNoteBu}`} onClick={(e) => { setOpenExportModal(true); setSelectedEmailGroups([]); }}>
                                            <Download /> <span>Export Report</span>
                                        </Link>
                                    </div>
                                </div>

                                <div className={`${styles.IncomeListingBody}`}>
                                    <div className={`${styles.IncomeListSec}`}>
                                        <ReportList rentrollList={rentrollList} />
                                    </div>
                                </div>

                                <div className={`${styles.ListMobileView}`}>
                                    {rentrollList?.map((item, index) => {
                                        return <div key={index} className={`${styles.MaintenanceReqCard}`}>
                                            <div className={`${styles.FirstSec} ${styles.ProfileImg}`}>

                                                <div className={`${styles.ProNameIMG}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); if (item?.id) { redirect.push("/people/tenants/details/" + item.id); } }}>
                                                    {item?.tenant_image !== "" ? (<img src={item?.tenant_image} alt="" />) : (<p><Initials fullName={item?.tenant_data?.name} /></p>)}
                                                </div>
                                                <div>
                                                    <p className={`${styles.Name} ${styles.Hover}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); if (item?.id) { redirect.push("/people/tenants/details/" + item.id); } }}>
                                                        {item?.tenant_data?.name}
                                                    </p>
                                                    <p className={`${styles.Name} ${styles.Hover}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); redirect.push("/properties/details/" + item?.property_id); }}>{item?.property_data?.name} - {item?.apt_name}</p>
                                                </div>
                                            </div>
                                            <div className={`${styles.SecondSec}`}>
                                                <div className={`${styles.Flex}`}>
                                                    <p className={`${styles.Name}`}>Email: <span>{item?.tenant_data?.email}</span></p>
                                                    <p className={`${styles.Name}`}>Rent Due Day: <span>1st</span></p>
                                                </div>
                                                <div className={`${styles.Flex}`}>
                                                    <p className={`${styles.Name}`}>
                                                        Rent:
                                                        <span>{item?.rent?.toLocaleString('en-US', {
                                                            style: 'currency',
                                                            currency: 'USD',
                                                            minimumFractionDigits: 2,
                                                            maximumFractionDigits: 2
                                                        })}</span>
                                                    </p>
                                                    <p className={`${styles.Name}`}>
                                                        Outstanding:
                                                        <span>{item?.available_balance2?.toLocaleString('en-US', {
                                                            style: 'currency',
                                                            currency: 'USD',
                                                            minimumFractionDigits: 2,
                                                            maximumFractionDigits: 2
                                                        })}</span>
                                                    </p>
                                                </div>
                                            </div>
                                            <div className={`${styles.ThirdSec}`}>
                                                <p className={`${styles.Flex}`}>
                                                    <p className={`${styles.Name} ${styles.Hover}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); redirect.push("/leases/details/" + item?.id); }}>{dayjs(item?.lease_start_date).format('MM/DD/YYYY') + ' - ' + dayjs(item?.lease_end_date).format('MM/DD/YYYY')}</p>
                                                    <p className={`${styles.Name}`}>
                                                        DOB: <span>{item?.tenant_data?.birth_date ? dayjs(item?.tenant_data?.birth_date).format('MM-DD-YYYY') : '-'}</span>
                                                    </p>
                                                </p>
                                            </div>
                                        </div>
                                    })}
                                </div>


                            </>}

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <Dialog
            open={openExportModal}
            fullWidth
            maxWidth="xs"
            onClose={(e) => setOpenExportModal(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="NewPopUp CustomWidthPopUs MobileForm"
        >
            <DialogTitle id="alert-dialog-title">
                <button className={`${styles.BackAddBU}`} onClick={(e) => setOpenExportModal(false)}><ArrowLeft /></button>
                <span>Export Pinata Report</span>
                <button onClick={(e) => setOpenExportModal(false)}><X /></button>
            </DialogTitle>
            <DialogContent>
                <div className={`${styles.AddprospectFirstStepForm}`}>
                    <p className={`${styles.AddprospectFirstStepFormTitle}`}> Please select a email group before exporting the Pinata Report.</p>
                    <p className={`${styles.AddprospectFirstStepFormTitleTwo}`}>The full report will be generated using your selected email group.The file will include tenant, lease, rent, and outstanding balance details.</p>
                    <div className={`${styles.HalfStepFormRow}`}>
                        <div className={`${styles.HalfStepFormFullSec} FormGroup`}>
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label" shrink={selectedEmailGroups.length === 0 || selectedEmailGroups.length > 0}>Select Email Group*</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Select Email Group*"
                                    displayEmpty
                                    multiple
                                    value={selectedEmailGroups || []}
                                    onChange={(e) => {
                                        if (e.target.value?.indexOf('No Group') > -1) {
                                            setSelectedEmailGroups([]);
                                        } else {
                                            setSelectedEmailGroups(e.target.value);
                                        }
                                    }}
                                    renderValue={(selected) => {
                                        if (!selected || selected.length === 0) {
                                            return (
                                                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                                                    <Chip label="No Group" />
                                                </Box>
                                            );
                                        }
                                        return <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                                            {emailGroupList?.map(item => {
                                                return (selected?.indexOf(item?.id) > -1) ? (<Chip key={item?.id} label={item?.title} />) : null;
                                            })}
                                        </Box>
                                    }}
                                >
                                    <MenuItem value="No Group">
                                        <Checkbox checked={emailGroupList.length > 0 && selectedEmailGroups.length === 0} />
                                        <ListItemText primary="No Group" />
                                    </MenuItem>
                                    {emailGroupList?.map((i) => {
                                        return (<MenuItem key={i?.id} value={i?.id}>
                                            <Checkbox checked={selectedEmailGroups.indexOf(i?.id) > -1} />
                                            <ListItemText primary={i?.title} />
                                        </MenuItem>);
                                    })}
                                </Select>
                            </FormControl>
                        </div>
                    </div>
                    <div className={`${styles.ButtonAction}`}>
                        <Button onClick={(e) => setOpenExportModal(false)} className="CancelPopupBU">Cancel</Button>
                        <Button className="SubmitPopupBU" onClick={(e) => exportTenants()}>Export</Button>
                    </div>
                </div>
            </DialogContent>
        </Dialog>

        <Footer />
    </>);
}

export default withAuthenticationRequired(PinataReport, {
    onRedirecting: () => <Loader />,
});